import { DeliveryUsersRepository } from '../repositories/delivery-users.repository'

import { GetUsersParams, GetUsersResponse } from '@/core/types/delivery-users.types'

const deliveryUsersRepository = new DeliveryUsersRepository()

export class DeliveryUsersService {
    async getUsers(params: GetUsersParams): Promise<GetUsersResponse> {
        const response = await deliveryUsersRepository.getUsers(params)
        return response.data
    }
}
